export function carrierVF({ value }) {
  return value.replace(/ Air((ways)|(lines))?$/, "");
}

export function durationVF({ value }) {
  const minutes = value % 60;
  const hours = parseInt((value - minutes) / 60);
  return hours ? `${hours}h${minutes}m` : `${minutes}m`;
}

const DEPARTS_AT__FIELDS = new Set([
  "departs_at",
  "f1__departs_at",
  "f1__departs_at",
]);

export function isDepartsAtField(field) {
  return DEPARTS_AT__FIELDS.has(field);
}

export const OG_BASELINE_SAVINGS_COLDEF = {
  headerName: "[O] Savings (vs Baseline)",
  field: "Fare Savings",
  type: "moneyColumn",
};
export const OG_BASELINE_TOTAL_SAVINGS_COLDEF = {
  headerName: "[O] Total Savings (vs Baseline)",
  field: "Total Savings",
  type: "moneyColumn",
};

export const OG_TARGET_SAVINGS_COLDEF = {
  headerName: "[O] Savings (vs Target)",
  field: "Fare Savings (vs Target)",
  type: "moneyColumn",
};
export const OG_TARGET_TOTAL_SAVINGS_COLDEF = {
  headerName: "[O] Total Savings (vs Target)",
  field: "Total Savings (vs Target)",
  type: "moneyColumn",
};

export const CA_SAVINGS_COLDEF = {
  headerName: "Savings (vs CA)",
  field: "[Calc] Current Avg Savings",
  type: "moneyColumn",
};
export const CA_TOTAL_SAVINGS_COLDEF = {
  headerName: "Total Savings (vs CA)",
  field: "[Calc] Current Avg Total Savings",
  type: "moneyColumn",
};

export const OG_CA_SAVINGS_COLDEF = {
  headerName: "[O] Savings (vs CA)",
  field: "[O] Current Avg Savings",
  type: "moneyColumn",
};
export const OG_CA_TOTAL_SAVINGS_COLDEF = {
  headerName: "[O] Total Savings (vs CA)",
  field: "[O] Current Avg Total Savings",
  type: "moneyColumn",
};

export const OG_FARE_COLDEF = {
  headerName: "[O] Opp Fare",
  field: "fare",
  type: "moneyColumn",
};
export const ONEWAY__OG_FLIGHTNO_COLDEF = {
  headerName: "[O] Flight #",
  field: "flight_number_0",
  type: "textColumn",
  __itinMode: "oneway",
};
export const ROUNDTRIP_F1__OG_FLIGHTNO_COLDEF = {
  headerName: "[O] Flight # (Out)",
  field: "f1__flight_number_0",
  type: "textColumn",
  __itinMode: "roundtrip",
};
export const ROUNDTRIP_F2__OG_FLIGHTNO_COLDEF = {
  headerName: "[O] Flight # (Ret)",
  field: "f2__flight_number_0",
  type: "textColumn",
  __itinMode: "roundtrip",
};
export const ONEWAY__OG_CARRIER_COLDEF = {
  headerName: "[O] Carrier",
  field: "carrier_0",
  type: "textColumn",
  valueFormatter: carrierVF,
  __itinMode: "oneway",
};
export const ROUNDTRIP_F1__OG_CARRIER_COLDEF = {
  headerName: "[O] Carrier (Out)",
  field: "f1__carrier_0",
  type: "textColumn",
  valueFormatter: carrierVF,
  __itinMode: "roundtrip",
};
export const ROUNDTRIP_F2__OG_CARRIER_COLDEF = {
  headerName: "[O] Carrier (Ret)",
  field: "f2__carrier_0",
  type: "textColumn",
  valueFormatter: carrierVF,
  __itinMode: "roundtrip",
};

export const OG_CA_FARE_COLDEF = {
  headerName: "CA Fare",
  field: "Current Avg Fare",
  type: "moneyColumn",
};
export const OG_TARGET_FARE_COLDEF = {
  headerName: "Target Fare",
  field: "Target Fare",
  type: "moneyColumn",
};

export const NUM_FLOPPTIONS_BTN_MODAL__COLDEF = {
  headerName: "Opts",
  field: "num_flopptions",
  type: "integerColumn",
  cellRenderer: "viewFlopptionsButtonCellRenderer",
  width: 80,
  pinned: "right",
};
export const REPORT_ACTION_BTN_COLDEF = {
  headerName: "",
  field: "action",
  cellRenderer: "reportActionButtonCellRenderer",
  width: 48,
  pinned: "right",
};

export const PINNED_TRIPID__COLDEF = {
  headerName: "Trip ID",
  field: "[Book] TripId",
  type: "textColumn",
  pinned: "left",
};
export const PINNED_GROUP_NUMBER__COLDEF = {
  headerName: "Group#-Tour#",
  field: "group#-tour#",
  type: "textColumn",
  pinned: "left",
  __appMode: "dvy",
};
export const ONEWAY__PINNED_LEG__COLDEF = {
  headerName: "Leg",
  field: "leg",
  type: "categoryColumn",
  pinned: "left",
  __itinMode: "oneway",
};
export const PLANNER__COLDEF = {
  headerName: "Planner",
  field: "[Book] Planner",
  type: "categoryColumn",
};
export const ACTUAL_COUNT__COLDEF = {
  headerName: "Act Cnt",
  field: "Act Cnt",
  type: "integerColumn",
};
export const XCA__TCC__COLDEF = {
  headerName: "TCC",
  field: "[Book] TCC",
  type: "categoryColumn",
  __appMode: "xca",
};
export const XCA__SALES__COLDEF = {
  headerName: "Sales",
  field: "[Book] Sales",
  type: "categoryColumn",
  __appMode: "xca",
};
export const PINNED_TOURCENTER_NUMBER__COLDEF = {
  headerName: "Tour Center",
  field: "[Book] Tourcenter",
  type: "textColumn",
  pinned: "left",
  __appMode: "xca",
};
export const NUM_PASSENGERS__COLDEF = {
  headerName: "# Pax",
  field: "num_passengers",
  type: "integerColumn",
};

export const ONEWAY__CARRIER_0 = {
  headerName: "Opp Carrier",
  field: "carrier_0",
  type: "categoryColumn",
  valueFormatter: carrierVF,
  __itinMode: "oneway",
};
export const ROUNDTRIP_F1__CARRIER_0 = {
  headerName: "Opp Carrier (Out)",
  field: "f1__carrier_0",
  type: "categoryColumn",
  valueFormatter: carrierVF,
  __itinMode: "roundtrip",
};
export const ROUNDTRIP_F2__CARRIER_0 = {
  headerName: "Opp Carrier (Ret)",
  field: "f2__carrier_0",
  type: "categoryColumn",
  valueFormatter: carrierVF,
  __itinMode: "roundtrip",
};

export const ONEWAY__FLIGHTNO_0 = {
  headerName: "Opp Flight #",
  field: "flight_number_0",
  type: "textColumn",
  __itinMode: "oneway",
};
export const ROUNDTRIP_F1__FLIGHTNO_0 = {
  headerName: "Opp Flight # (Out)",
  field: "f1__flight_number_0",
  type: "textColumn",
  __itinMode: "roundtrip",
};
export const ROUNDTRIP_F2__FLIGHTNO_0 = {
  headerName: "Opp Flight # (Ret)",
  field: "f2__flight_number_0",
  type: "textColumn",
  __itinMode: "roundtrip",
};

export const ONEWAY__ORIG = {
  headerName: "Orig",
  field: "orig",
  type: "categoryColumn",
  __itinMode: "oneway",
};
export const ROUNDTRIP_F1__ORIG = {
  headerName: "Orig (Out)",
  field: "f1__orig",
  type: "categoryColumn",
  __itinMode: "roundtrip",
};
export const ROUNDTRIP_F2__ORIG = {
  headerName: "Orig (Ret)",
  field: "f2__orig",
  type: "categoryColumn",
  __itinMode: "roundtrip",
};

export const ONEWAY__DEST = {
  headerName: "Dest",
  field: "dest",
  type: "categoryColumn",
  __itinMode: "oneway",
};
export const ROUNDTRIP_F1__DEST = {
  headerName: "Dest (Out)",
  field: "f1__dest",
  type: "categoryColumn",
  __itinMode: "roundtrip",
};
export const ROUNDTRIP_F2__DEST = {
  headerName: "Dest (Ret)",
  field: "f2__dest",
  type: "categoryColumn",
  __itinMode: "roundtrip",
};

export const ONEWAY__STOP_0 = {
  headerName: "Stop 1",
  field: "stop_0",
  type: "categoryColumn",
  __itinMode: "oneway",
};
export const ROUNDTRIP_F1__STOP_0 = {
  headerName: "Stop 1 (Out)",
  field: "f1__stop_0",
  type: "categoryColumn",
  __itinMode: "roundtrip",
};
export const ROUNDTRIP_F2__STOP_0 = {
  headerName: "Stop 1 (Ret)",
  field: "f2__stop_0",
  type: "categoryColumn",
  __itinMode: "roundtrip",
};

export const ONEWAY__STOP_1 = {
  headerName: "Stop 2",
  field: "stop_1",
  type: "categoryColumn",
  __itinMode: "oneway",
};
export const ROUNDTRIP_F1__STOP_1 = {
  headerName: "Stop 2 (Out)",
  field: "f1__stop_1",
  type: "categoryColumn",
  __itinMode: "roundtrip",
};
export const ROUNDTRIP_F2__STOP_1 = {
  headerName: "Stop 2 (Ret)",
  field: "f2__stop_1",
  type: "categoryColumn",
  __itinMode: "roundtrip",
};

export const ONEWAY__DEPARTS_AT = {
  headerName: "Departs At",
  field: "departs_at",
  type: "timestampColumn",
  __itinMode: "oneway",
};
export const ROUNDTRIP_F1__DEPARTS_AT = {
  headerName: "Departs At (Out)",
  field: "f1__departs_at",
  type: "timestampColumn",
  __itinMode: "roundtrip",
};
export const ROUNDTRIP_F2__DEPARTS_AT = {
  headerName: "Departs At (Ret)",
  field: "f2__departs_at",
  type: "timestampColumn",
  __itinMode: "roundtrip",
};

export const ONEWAY__CARRIER_1 = {
  headerName: "Post-Stop Carrier",
  field: "carrier_1",
  type: "categoryColumn",
  valueFormatter: carrierVF,
  __itinMode: "oneway",
};
export const ROUNDTRIP_F1__CARRIER_1 = {
  headerName: "Post-Stop Carrier (Out)",
  field: "f1__carrier_1",
  type: "categoryColumn",
  valueFormatter: carrierVF,
  __itinMode: "roundtrip",
};
export const ROUNDTRIP_F2__CARRIER_1 = {
  headerName: "Post-Stop Carrier (Ret)",
  field: "f2__carrier_1",
  type: "categoryColumn",
  valueFormatter: carrierVF,
  __itinMode: "roundtrip",
};

export const ONEWAY__FLIGHTNO_1 = {
  headerName: "Post-Stop Flight #",
  field: "flight_number_1",
  type: "textColumn",
  __itinMode: "oneway",
};
export const ROUNDTRIP_F1__FLIGHTNO_1 = {
  headerName: "Post-Stop Flight # (Out)",
  field: "f1__flight_number_1",
  type: "textColumn",
  __itinMode: "roundtrip",
};
export const ROUNDTRIP_F2__FLIGHTNO_1 = {
  headerName: "Post-Stop Flight # (Ret)",
  field: "f2__flight_number_1",
  type: "textColumn",
  __itinMode: "roundtrip",
};

export const ONEWAY__CARRIER_2 = {
  headerName: "Post-2nd-Stop Carrier",
  field: "carrier_2",
  type: "categoryColumn",
  valueFormatter: carrierVF,
  __itinMode: "oneway",
};
export const ROUNDTRIP_F1__CARRIER_2 = {
  headerName: "Post-2nd-Stop Carrier (Out)",
  field: "f1__carrier_2",
  type: "categoryColumn",
  valueFormatter: carrierVF,
  __itinMode: "roundtrip",
};
export const ROUNDTRIP_F2__CARRIER_2 = {
  headerName: "Post-2nd-Stop Carrier (Ret)",
  field: "f2__carrier_2",
  type: "categoryColumn",
  valueFormatter: carrierVF,
  __itinMode: "roundtrip",
};

export const ONEWAY__FLIGHTNO_2 = {
  headerName: "Post-2nd-Stop Flight #",
  field: "flight_number_2",
  type: "textColumn",
  __itinMode: "oneway",
};
export const ROUNDTRIP_F1__FLIGHTNO_2 = {
  headerName: "Post-2nd-Stop Flight # (Out)",
  field: "f1__flight_number_2",
  type: "textColumn",
  __itinMode: "roundtrip",
};
export const ROUNDTRIP_F2__FLIGHTNO_2 = {
  headerName: "Post-2nd-Stop Flight # (Ret)",
  field: "f2__flight_number_2",
  type: "textColumn",
  __itinMode: "roundtrip",
};

export const ONEWAY__ARRIVES_AT = {
  headerName: "Arrives At",
  field: "arrives_at",
  type: "timestampColumn",
  __itinMode: "oneway",
};
export const ROUNDTRIP_F1__ARRIVES_AT = {
  headerName: "Arrives At (Out)",
  field: "f1__arrives_at",
  type: "timestampColumn",
  __itinMode: "roundtrip",
};
export const ROUNDTRIP_F2__ARRIVES_AT = {
  headerName: "Arrives At (Ret)",
  field: "f2__arrives_at",
  type: "timestampColumn",
  __itinMode: "roundtrip",
};

export const ONEWAY__DURATION = {
  // TODO: Fix text alignment in cell
  // TODO: Fix filter
  headerName: "Trip Duration",
  field: "duration",
  type: "integerColumn",
  valueFormatter: durationVF,
  __itinMode: "oneway",
};
export const ROUNDTRIP_F1__DURATION = {
  headerName: "Trip Duration (Out)",
  field: "f1__duration",
  type: "integerColumn",
  valueFormatter: durationVF,
  __itinMode: "roundtrip",
};
export const ROUNDTRIP_F2__DURATION = {
  headerName: "Trip Duration (Ret)",
  field: "f2__duration",
  type: "integerColumn",
  valueFormatter: durationVF,
  __itinMode: "roundtrip",
};

export const ONEWAY__STOP_DURATION_0 = {
  // TODO: Fix text alignment in cell
  // TODO: Fix filter
  headerName: "Stop Duration",
  field: "stop_duration_0",
  type: "integerColumn",
  valueFormatter: durationVF,
  __itinMode: "oneway",
};
export const ROUNDTRIP_F1__STOP_DURATION_0 = {
  headerName: "Stop Duration (Out)",
  field: "f1__stop_duration_0",
  type: "integerColumn",
  valueFormatter: durationVF,
  __itinMode: "roundtrip",
};
export const ROUNDTRIP_F2__STOP_DURATION_0 = {
  headerName: "Stop Duration (Ret)",
  field: "f2__stop_duration_0",
  type: "integerColumn",
  valueFormatter: durationVF,
  __itinMode: "roundtrip",
};

export const ONEWAY__STOP_DURATION_1 = {
  // TODO: Fix text alignment in cell
  // TODO: Fix filter
  headerName: "Stop Duration",
  field: "stop_duration_1",
  type: "integerColumn",
  valueFormatter: durationVF,
  __itinMode: "oneway",
};
export const ROUNDTRIP_F1__STOP_DURATION_1 = {
  headerName: "Stop Duration (Out)",
  field: "f1__stop_duration_1",
  type: "integerColumn",
  valueFormatter: durationVF,
  __itinMode: "roundtrip",
};
export const ROUNDTRIP_F2__STOP_DURATION_1 = {
  headerName: "Stop Duration (Ret)",
  field: "f2__stop_duration_1",
  type: "integerColumn",
  valueFormatter: durationVF,
  __itinMode: "roundtrip",
};
